import { render } from "./subsidies.vue?vue&type=template&id=5b98889f&scoped=true"
import script from "./subsidies.vue?vue&type=script&lang=js"
export * from "./subsidies.vue?vue&type=script&lang=js"

import "./subsidies.vue?vue&type=style&index=0&id=5b98889f&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b98889f"]])

export default __exports__